/**
 * 关卡加载与构建。
 *
 * 关卡表就是一行一条 SBN v1，和 App 端共用同一份 levels.txt
 * （当初从 starbattle-package 拷过来的）。解与区域网格都在浏览器现算 ——
 * 实测 100 关全解完约 10ms，无需预烘焙。
 */

import { decodeSbn, isSbnV1 } from '../core/sbn.js';
import { solve } from '../core/solver.js';

/**
 * @typedef {object} Level
 * @property {number} index 关卡序号，从 1 起
 * @property {string} sbn
 * @property {number} dim
 * @property {number} stars
 * @property {number[][]} regionGrid
 * @property {number[]} solution
 */

/**
 * 由 SBN 构建可玩关卡（解码 + 求解）。
 * @param {string} sbn
 * @param {number} [index] 关卡序号，仅用于展示
 * @returns {Level}
 * @throws {Error} SBN 非法、无解、或解不唯一
 */
export function buildLevel(sbn, index = 0) {
    if (!isSbnV1(sbn)) {
        throw new Error('不是合法的 SBN 谜题串');
    }
    const p = decodeSbn(sbn);
    const { solutions } = solve(p.regionGrid, p.stars, { limit: 2 });

    if (solutions.length === 0) throw new Error('这个谜题无解');
    if (solutions.length > 1) throw new Error('这个谜题的解不唯一，无法判定对错');

    return {
        index,
        sbn,
        dim: p.dim,
        stars: p.stars,
        regionGrid: p.regionGrid,
        solution: solutions[0],
    };
}
